// eslint-disable-next-line import/no-amd
define([
    '../../../utils/Globals',
    'jquery',
    'underscore',
    '../../app/models/MabinsoModel',
    '../../interface/models/InterfaceFinishedModel',
    '../../../utils/WebSocket'
], (Globals, $, _, MabinsoModel) => {
    const SchemaUserModel = MabinsoModel.extend({
        urlRoot: Globals.baseUrl + 'schemas/userSchema',
        urlSocket: 'interfaces/socket/status',
        urlFallback: Globals.baseUrl + 'interfaces/status',
        defaults: {}
    });

    return SchemaUserModel;
});




// WEBPACK FOOTER //
// ./src/components/schema/models/SchemaUserModel.js